import { baixarModeloPlanilha, lerPlanilha } from "./importacaoPlanilha";
import { COLUNAS_IMPORTACAO, INSTRUCOES_CADASTRO } from "./importacaoFornecedores";

/**
 * Colunas da planilha de clientes: o cadastro é o mesmo do fornecedor, sem a
 * previsão de pagamento. "Cliente" entra como apelido do nome.
 */
export const COLUNAS_IMPORTACAO_CLIENTES = COLUNAS_IMPORTACAO.filter((c) => c.campo !== "previsaoPagamentoDias").map((c) =>
	c.campo === "nome" ? { ...c, apelidos: [...c.apelidos, "cliente", "nomecliente", "nomedocliente"] } : c
);

export function lerPlanilhaClientes(file) {
	return lerPlanilha(file, COLUNAS_IMPORTACAO_CLIENTES, { exemploCabecalho: "Nome, CPF/CNPJ, Telefone", entidade: "cliente" });
}

export function baixarModeloImportacaoClientes() {
	baixarModeloPlanilha({
		colunas: COLUNAS_IMPORTACAO_CLIENTES,
		exemplo: [
			"Mercado Bom Preço Ltda",
			"Bom Preço",
			"98.765.432/0001-10",
			"987.654.321.000",
			"compras@bompreco.com.br",
			"(11) 98888-7777",
			"13010-000",
			"SP",
			"Campinas",
			"Centro",
			"Rua das Flores, 100",
			"-22,9056",
			"-47,0608",
			"15/01/2025",
			"Alface - Crespa (kg); Tomate - Cereja (un)",
		],
		instrucoes: [
			["Como preencher a planilha de clientes"],
			[],
			["Obrigatórios", "Nome e CPF/CNPJ. As demais colunas são opcionais e podem ficar vazias."],
			INSTRUCOES_CADASTRO.cpfCnpj("Cliente"),
			["Telefone", "Com DDD."],
			INSTRUCOES_CADASTRO.latitudeLongitude,
			INSTRUCOES_CADASTRO.dataEntradaBase,
			...INSTRUCOES_CADASTRO.produtos,
		],
		aba: "Clientes",
		arquivo: "modelo-importacao-clientes.xlsx",
	});
}
